import { render, staticRenderFns } from "./ReglementForm.vue?vue&type=template&id=47b276b6&"
import script from "./ReglementForm.vue?vue&type=script&lang=js&"
export * from "./ReglementForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/easy_dev/extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47b276b6')) {
      api.createRecord('47b276b6', component.options)
    } else {
      api.reload('47b276b6', component.options)
    }
    module.hot.accept("./ReglementForm.vue?vue&type=template&id=47b276b6&", function () {
      api.rerender('47b276b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/reglements/components/ReglementForm.vue"
export default component.exports